<template>
  <el-container style="height: 100%;">
    <el-header style="height: 50px;">
      <el-row>
        <el-col :span="4">
          <div class="status-button" :class="{ process: showStatus === 1 }" @click="setStatus(1)">
            进行中
          </div>
        </el-col>
        <el-col :span="4">
          <div class="status-button" :class="{ finish: showStatus === 2 }" @click="setStatus(2)">
            已完成
          </div>
        </el-col>
        <el-col :span="4">
          <div class="status-button" :class="{ cancel: showStatus === 3 }" @click="setStatus(3)">
            已取消
          </div>
        </el-col>
      </el-row>
    </el-header>
    <el-container style="height: calc(100vh - 120px);">
      <el-aside width="330px" class="aside-custom">
        <div class="popover-wrapper" style="flex-shrink: 0;">
          <el-input style="width: 90%;" placeholder="请输入搜索内容" prefix-icon="el-icon-search" v-model="searchText">
          </el-input>
          <el-popover style="cursor: pointer;margin-left: 2%;padding-top: 2px;" placement="bottom" width="500"
            trigger="click">
            <svg t="1750918798427" slot="reference" class="icon" viewBox="0 0 1024 1024" version="1.1"
              xmlns="http://www.w3.org/2000/svg" p-id="8560" width="25" height="25">
              <path
                d="M741.248 79.68l-234.112 350.08v551.488l55.296 24.704v-555.776l249.152-372.544c8.064-32.96-10.496-59.712-41.152-59.712h-709.248c-30.464 0-49.28 26.752-41.344 59.712l265.728 372.544v432.256l55.36 24.704v-478.592l-248.896-348.864h649.216z m-68.032 339.648c0-16.832 12.096-30.592 27.264-30.848h277.888c15.232 0 27.712 13.824 27.712 30.848s-12.416 30.848-27.712 30.848h-277.888c-15.168-0.32-27.264-14.016-27.264-30.848z m0 185.216c0-16.832 12.096-30.592 27.264-30.848h277.888c15.232 0 27.712 13.824 27.712 30.848s-12.416 30.848-27.712 30.848h-277.888c-15.168-0.256-27.264-14.016-27.264-30.848z m0 185.28c0-16.832 12.096-30.592 27.264-30.848h277.888c15.232 0 27.712 13.824 27.712 30.848s-12.416 30.848-27.712 30.848h-277.888c-15.168-0.32-27.264-13.952-27.264-30.848z"
                p-id="8561"></path>
            </svg>
            <el-form label-width="80px" size="small">
              <el-form-item label="起止日期">
                <el-date-picker v-model="dateRange" type="daterange" range-separator="至" start-placeholder="开始日期"
                  end-placeholder="结束日期" style="width: 100%;"></el-date-picker>
              </el-form-item>
              <el-form-item label="任务类型">
                <el-select v-model="searchTaskType" placeholder="请选择" clearable>
                  <el-option v-for="item in dictMap.taskType" :key="item.dictCode" :label="item.dictName"
                    :value="item.dictCode">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" size="small" @click="handleSearch" style="width: 100%;">搜索</el-button>
              </el-form-item>
            </el-form>
          </el-popover>
        </div>
        <!-- 滚动区域（任务卡片 + 加载更多） -->
        <div class="card-scroll-area">
          <el-card class="task-card" :class="{ selected: selectedTaskId === item.id }" v-for="(item, index) in taskList"
            :key="index" shadow="hover" @click.native="selectedTask(item.id)">
            <div>{{ item.taskName }}</div>
            <div>{{ formatDate(item.taskTime) }}</div>
          </el-card>
          <div class="load-label">
            <i v-if="listLoadStatus" class="el-icon-loading"></i>
            <span v-if="!listLoadStatus && loadLabelStatus" @click="loadMove()">加载更多</span>
            <span v-if="!loadLabelStatus">已经到底了</span>
          </div>
        </div>
      </el-aside>
      <el-container style="overflow-y: auto;">
        <el-main style="background-color: rgb(255, 255, 255); border-radius: 10px; padding: 20px;">
          <!-- 骨架屏 loading 效果 -->
          <div v-if="loadingTaskDetail" class="skeleton-container">
            <div class="skeleton-header">
              <div class="skeleton-avatar shimmer"></div>
              <div class="skeleton-text-group">
                <div class="skeleton-title shimmer"></div>
                <div class="skeleton-subtitle shimmer"></div>
              </div>
            </div>
            <div class="skeleton-line shimmer" style="width: 60%;"></div>
            <div class="skeleton-line shimmer" style="width: 80%;"></div>
            <div class="skeleton-line shimmer" style="width: 50%;"></div>
          </div>
          <div v-else-if="selectedTaskInfo">
            <!-- 计划信息块 -->
            <div v-if="selectedTaskInfo.planInfoTo" style="margin-bottom: 30px;">
              <div style="display: flex; align-items: center; margin-bottom: 10px;">
                <el-image :src="selectedTaskInfo.planInfoTo.icon"
                  style="width: 60px; height: 60px; border-radius: 8px; margin-right: 20px; cursor: pointer;"
                  fit="cover" :preview-src-list="[selectedTaskInfo.planInfoTo.icon]" preview-teleported
                  :initial-index="0" />
                <div>
                  <div style="font-size: 20px; font-weight: bold;">
                    {{ selectedTaskInfo.planInfoTo.planName || '未关联计划' }}
                  </div>
                  <div style="color: #999; font-size: 14px;">
                    {{ selectedTaskInfo.planInfoTo.description || '无描述信息' }}
                  </div>
                </div>
              </div>
              <div style="margin-bottom: 6px;"><strong>计划说明：</strong>{{ selectedTaskInfo.planInfoTo.planInfo || '无' }}
              </div>
            </div>

            <!-- 任务信息块 -->
            <div>
              <div
                style="font-size: 18px; font-weight: bold; margin-bottom: 10px;display: flex;justify-content: space-between;align-items: center;">
                <span>任务信息</span>
                <div>
                  <el-tooltip content="新增日志" placement="top">
                    <img style="width: 30px;height: 30px; margin-right: 10px;cursor: pointer;"
                      src="@/assets/ioc/task/log.png" @click="recordTaskLogOpen()">
                  </el-tooltip>
                  <el-tooltip content="分享任务" placement="top">
                    <img style="width: 30px;height: 30px; margin-right: 10px;cursor: pointer;"
                      src="@/assets/ioc/task/share.png" @click="shareTaskOpen()">
                  </el-tooltip>
                  <el-tooltip content="编辑任务" placement="top">
                    <img style="width: 30px;height: 30px; margin-right: 10px;cursor: pointer;"
                      src="@/assets/ioc/task/edit.png" @click="editTaskOpen()">
                  </el-tooltip>
                </div>

              </div>
              <div style="margin-bottom: 10px; font-weight: 500; color: #303133;"><strong>任务名称：</strong>{{ selectedTaskInfo.taskName }}</div>
              <div style="margin-bottom: 10px; font-weight: 500; color: #303133;"><strong>任务描述：</strong></div>
              <div class="task-desc">{{ selectedTaskInfo.description }}</div>
              <div style="margin-bottom: 10px; font-weight: 500; color: #303133;"><strong>任务时间：</strong>{{ formatDate(selectedTaskInfo.taskTime) }}</div>
              <div style="margin-bottom: 10px; font-weight: 500; color: #303133;"><strong>任务类型：</strong>
                <span>
                  {{(dictMap.taskType || []).find(item => item.dictCode === selectedTaskInfo.taskType)?.dictName || ''}}
                </span>
              </div>
              <!-- 任务日志 -->
              <div v-if="selectedTaskInfo.taskLogListTo && selectedTaskInfo.taskLogListTo.length > 0"
                style="margin-top:30px">
                <el-collapse v-model="logCollapseActive">
                  <el-collapse-item title="任务日志" name="taskLog" style="font-size: 17px;">
                    <el-timeline>
                      <el-timeline-item v-for="(log) in selectedTaskInfo.taskLogListTo" :key="log.id"
                        :timestamp="formatDate(log.createTime)" placement="top">
                        <div style="display: flex; justify-content: space-between; align-items: flex-start;">
                          <div class="task-log-content" style="white-space: pre-wrap; flex: 1;">
                            {{ log.logContent }}
                          </div>
                          <div style="flex-shrink: 0; margin-left: 10px;">
                            <el-button type="text" size="mini" icon="el-icon-edit" @click="editTaskLogOpen(log)"></el-button>
                            <el-button type="text" size="mini" icon="el-icon-delete" style="color: #f56c6c;" @click="removeTaskLog(log)"></el-button>
                          </div>
                        </div>
                        <div v-if="log.annexFileList && log.annexFileList.length > 0" style="margin-top: 10px;">
                          <AnnexFileView :fileList="log.annexFileList" />
                        </div>
                      </el-timeline-item>
                    </el-timeline>
                  </el-collapse-item>
                </el-collapse>
              </div>
              <!-- itemToLists 渲染为列表 -->
              <div v-if="selectedTaskInfo.itemToList?.length > 0" class="remark-content-container">
                <strong class="remark-title">任务项：</strong>
                <ul class="remark-list">
                  <li v-for="(item, index) in selectedTaskInfo.itemToList" :key="index" class="remark-item">
                    <!-- 标签 Popover -->
                    <el-popover placement="right" trigger="click" width="180" v-model="item._popoverVisible"
                      popper-class="remark-tag-popover">
                      <div class="tag-options">
                        <div v-for="dict in dictMap.taskItemLable" :key="dict.dictCode" class="tag-option-item"
                          @click="handleChangeItemLabel(item, dict)">
                          <span class="tag-color-dot" :style="{ backgroundColor: dict.color }"></span>
                          <span class="tag-name">{{ dict.dictName }}</span>
                        </div>
                      </div>

                      <template slot="reference">
                        <!-- 关键修改：添加固定宽度的外层容器 -->
                        <div class="tag-badge-container">
                          <span class="tag-badge" :style="{
                            backgroundColor: dictMap.taskItemLable.find(d => d.dictCode === item.label)?.color || '#909399'
                          }">
                            {{dictMap.taskItemLable.find(d => d.dictCode === item.label)?.dictName || '未分类'}}
                          </span>
                        </div>
                      </template>
                    </el-popover>

                    <!-- 编号 -->
                    <span class="item-number">{{ item.no }}.</span>
                    <!-- 内容 -->
                    <span class="item-content"> {{ item.itemContext }}</span>
                  </li>
                </ul>
              </div>
              <div v-if="selectedTaskInfo.annexFiles != null && selectedTaskInfo.annexFiles.length > 0">
                <strong>附件内容:</strong>
                <AnnexFileView :fileList="selectedTaskInfo.annexFiles" />
              </div>
              <!-- 操作按钮 -->
              <div class="icon-row">
                <el-tooltip effect="dark" content="完成任务" placement="top" v-if="selectedTaskInfo.status == 1">
                  <span class="icon-wrapper" style="margin-right: 10px;" @click="selectAction(selectedTaskInfo.id, 1)">
                    <svg t="1753254753676" class="icon" viewBox="0 0 1024 1024" version="1.1"
                      xmlns="http://www.w3.org/2000/svg" p-id="880" width="25" height="25">
                      <path
                        d="M460.8 694.044444L312.888889 546.133333c-2.844444-2.844444-2.844444-11.377778 0-14.222222l28.444444-28.444444c2.844444-2.844444 8.533333-2.844444 11.377778 0l108.088889 108.088889 247.466667-219.022223c5.688889-5.688889 11.377778-2.844444 17.066666 0l22.755556 25.6c5.688889 5.688889 5.688889 14.222222 0 19.911111l-287.288889 256z"
                        fill="#5C5C5C"></path>
                      <path
                        d="M512 56.888889c250.311111 0 455.111111 204.8 455.111111 455.111111s-204.8 455.111111-455.111111 455.111111S56.888889 762.311111 56.888889 512 261.688889 56.888889 512 56.888889m0-56.888889C230.4 0 0 230.4 0 512s230.4 512 512 512 512-230.4 512-512S793.6 0 512 0z"
                        fill="#5C5C5C"></path>
                    </svg>
                  </span>
                </el-tooltip>
                <el-tooltip effect="dark" content="取消任务" placement="top" v-if="selectedTaskInfo.status == 1">
                  <span class="icon-wrapper" style="margin-right: 10px;" @click="selectAction(selectedTaskInfo.id, 2)">
                    <svg t="1753328803437" class="icon" viewBox="0 0 1024 1024" version="1.1"
                      xmlns="http://www.w3.org/2000/svg" p-id="6930" width="25" height="25">
                      <path
                        d="M509.44 935.424c-233.984 0-424.448-190.464-424.448-424.448s190.464-424.448 424.448-424.448 424.448 190.464 424.448 424.448-190.464 424.448-424.448 424.448z m0-797.696c-205.824 0-373.248 167.424-373.248 373.248s167.424 373.248 373.248 373.248 373.248-167.424 373.248-373.248-167.424-373.248-373.248-373.248z"
                        fill="#000000" p-id="6931"></path>
                      <path
                        d="M338.944 681.472c-10.24-10.24-10.24-26.112 0-36.352l304.128-304.128c10.24-10.24 26.112-10.24 36.352 0s10.24 26.112 0 36.352l-304.128 304.128c-9.728 9.728-26.112 9.728-36.352 0z"
                        fill="#000000" p-id="6932"></path>
                      <path
                        d="M679.424 681.472c-10.24 10.24-26.112 10.24-36.352 0L338.944 376.832c-10.24-10.24-10.24-26.112 0-36.352s26.112-10.24 36.352 0l304.128 304.128c10.24 10.24 10.24 26.624 0 36.864z"
                        fill="#000000" p-id="6933"></path>
                    </svg>
                  </span>
                </el-tooltip>
                <el-tooltip effect="dark" content="删除任务" placement="top">
                  <span class="icon-wrapper" @click="selectAction(selectedTaskInfo.id, 3)">
                    <svg t="1753254801877" class="icon" viewBox="0 0 1024 1024" version="1.1"
                      xmlns="http://www.w3.org/2000/svg" p-id="1043" width="25" height="25">
                      <path
                        d="M745.6 928H294.4c-51.2 0-96-44.8-96-102.4V390.4c0-19.2 16-32 32-32s32 16 32 32v438.4c0 19.2 12.8 35.2 28.8 35.2h451.2c16 0 28.8-16 28.8-35.2V390.4c0-19.2 16-32 32-32s32 16 32 32v438.4c6.4 54.4-35.2 99.2-89.6 99.2zM905.6 291.2h-768c-19.2 0-35.2-16-35.2-35.2s16-35.2 35.2-35.2h768c19.2 0 35.2 16 35.2 35.2s-16 35.2-35.2 35.2zM649.6 163.2h-256c-19.2 0-35.2-16-35.2-35.2s16-35.2 35.2-35.2h256c19.2 0 35.2 16 35.2 35.2s-16 35.2-35.2 35.2z"
                        fill="#333333"></path>
                      <path
                        d="M409.6 739.2c-19.2 0-35.2-16-35.2-35.2v-288c0-19.2 16-35.2 35.2-35.2s35.2 16 35.2 35.2v288c0 19.2-16 35.2-35.2 35.2zM633.6 739.2c-19.2 0-35.2-16-35.2-35.2v-288c0-19.2 16-35.2 35.2-35.2s35.2 16 35.2 35.2v288c0 19.2-16 35.2-35.2 35.2z"
                        fill="#333333"></path>
                    </svg>
                  </span>
                </el-tooltip>
              </div>
            </div>
          </div>
          <div v-else>
            <el-empty description="无任务信息" />
          </div>
        </el-main>
      </el-container>
    </el-container>

    <!-- 侧边栏 -->
    <el-drawer title="编辑任务" :visible.sync="drawer" :before-close="handleClose" size="800px">
      <!-- 表单 -->
      <el-form ref="taskForm" :model="taskForm" label-width="100px" style="padding-right: 30px;">

        <el-form-item label="任务名" prop="taskName">
          <el-input maxlength="20" v-model="taskForm.taskName" placeholder="请输入任务名" />
        </el-form-item>

        <el-form-item label="任务描述" prop="taskName">
          <el-input type="textarea" autosize v-model="taskForm.description" placeholder="请输入任务描述" />
        </el-form-item>

        <el-form-item label="任务时间" prop="taskTime">
          <el-date-picker v-model="taskForm.taskTime" type="date" placeholder="选择日期">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="备注内容" prop="itemToList">
          <div v-for="(item, index) in taskForm.itemToList" :key="index"
            style="display: flex; align-items: center; margin-bottom: 8px;">
            <span style="
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                        width: 24px;
                        height: 24px;
                        background-color: #e0e0e0;
                        border-radius: 50%;
                        font-size: 12px;
                        color: #333;
                        margin-right: 15px;
                    ">
              {{ item.no }}
            </span>

            <!-- 序号内容 -->
            <el-input v-model="item.itemContext" placeholder="请输入内容" style="flex: 1; margin-right: 10px;"></el-input>

            <!-- 删除按钮 -->
            <el-button type="danger" icon="el-icon-delete" size="mini" @click="removeItem(index)" circle></el-button>
          </div>

          <!-- 添加按钮 -->
          <el-button type="primary" icon="el-icon-plus" size="mini" circle @click="addItem"></el-button>
        </el-form-item>

        <el-form-item label="任务类型" prop="taskType">
          <el-select v-model="taskForm.taskType" placeholder="请选择类型">
            <el-option v-for="(value, index) in dictMap.taskType" :key="index" :label=value.dictName
              :value=value.dictCode />
          </el-select>
        </el-form-item>

        <el-form-item label="附件内容">
          <AnnexFileUpload :value="taskForm.annexFiles" @update="taskForm.annexFiles = $event" ref="AnnexFileUpload" />
        </el-form-item>
      </el-form>

      <!-- 底部按钮 -->
      <div style="text-align:right; margin-top:20px; padding-right: 30px; margin-bottom: 20px;">
        <el-button @click="handleClose()">取消</el-button>
        <el-button type="primary" @click="submitFormTask">保存</el-button>
      </div>
    </el-drawer>

    <!-- 分享弹窗 -->
    <el-dialog title="任务分享" :visible.sync="shareDialogVisible" width="500px" :close-on-click-modal="false"
      :close-on-press-escape="true">
      <div style="word-break: break-all; margin-bottom: 10px;">
        {{ shareUrl }}
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="copyShareUrl">复制链接</el-button>
        <el-button type="primary" @click="goToShareUrl">跳转</el-button>
      </span>
    </el-dialog>
    <!-- 记录日志弹窗 -->
    <el-dialog title="新增任务日志" :visible.sync="logDialogVisible" width="600px" :close-on-click-modal="false">

      <el-form label-width="80px">

        <el-form-item label="日志内容">
          <el-input type="textarea" v-model="taskLogForm.logContent" :rows="6" placeholder="请输入日志内容" />
        </el-form-item>

        <el-form-item label="附件">

          <AnnexFileUpload :value="taskLogForm.annexFileList" @update="taskLogForm.annexFileList = $event" />

        </el-form-item>

      </el-form>

      <span slot="footer">

        <el-button @click="logDialogVisible = false">
          取消
        </el-button>

        <el-button type="primary" @click="saveTaskLogSubmit">
          保存
        </el-button>

      </span>

    </el-dialog>

    <!-- 编辑日志弹窗 -->
    <el-dialog title="编辑任务日志" :visible.sync="logEditDialogVisible" width="600px" :close-on-click-modal="false">
      <el-form label-width="80px">
        <el-form-item label="日志内容">
          <el-input type="textarea" v-model="taskLogEditForm.logContent" :rows="6" placeholder="请输入日志内容" />
        </el-form-item>
        <el-form-item label="附件">
          <AnnexFileUpload :value="taskLogEditForm.annexFileList" @update="taskLogEditForm.annexFileList = $event" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="logEditDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="updateTaskLogSubmit">保存</el-button>
      </span>
    </el-dialog>

  </el-container>
</template>

<script>
import { getTaskList, getTaskInfo, cancelTask, completeTask, deleteTask, updateTask, updateRemark, getShareCode, saveTaskLog, updateTaskLog, deleteTaskLog } from '@/api/task';
import { getDictList } from '@/api/dict'
import AnnexFileView from '@/components/AnnexFileView.vue';
import { formatDate } from '@/utils/navigator'
import { getUniqueCode } from '@/api/public';
import AnnexFileUpload from '@/components/AnnexFileUpload.vue';

export default {
  name: "taskPage",
  components: {
    AnnexFileView,
    AnnexFileUpload
  },
  data() {
    return {
      showStatus: 1,
      page: 1,
      limit: 10,
      searchTaskType: null,
      pageCount: 0,
      dateRange: [], // 存储起止日期，[startDate, endDate]
      searchText: '',
      taskList: [],
      selectedTaskId: null, //  选中任务卡的索引
      selectedTaskInfo: null,
      loadingTaskDetail: false,
      listLoadStatus: false,
      //编辑拉框
      drawer: false,
      uniqueCode: null,
      shareDialogVisible: false,
      shareUrl: '',
      taskForm: {
        taskName: "",
        taskTime: null,
        description: "",
        itemToList: [],
        taskType: 'work',
        annexFiles: []
      },
      // 日志弹窗
      logDialogVisible: false,

      // 日志表单
      taskLogForm: {
        logContent: '',
        annexFileList: []
      },

      // 编辑日志表单
      taskLogEditForm: {
        id: null,
        logContent: '',
        annexFileList: []
      },
      logEditDialogVisible: false,

      // 日志列表
      taskLogList: [],

      // 日志折叠，默认展开
      logCollapseActive: ['taskLog'],
      dictMap: {
        taskType: [],
        taskItemLable: []
      }
    };
  },
  mounted() {
    getDictList({ "classifyCode": "taskType" }).then(res => {
      this.dictMap.taskType = res.data
    })
    getDictList({ "classifyCode": "taskItemLable" }).then(res => {
      this.dictMap.taskItemLable = res.data
    })
    this.selectedTaskInfo.itemToList = this.selectedTaskInfo.itemToList.map(item => ({
      ...item,
      _popoverVisible: false
    }))

  },
  methods: {
    formatDate,
    setStatus(status) {
      if (status == this.showStatus) return
      this.selectedTaskInfo = null
      this.showStatus = status;
    },
    getTaskList(params) {
      return getTaskList(params).then(res => {
        this.taskList.push(...res.data.list)
        this.pageCount = res.data.pageCount
        this.page = res.data.page
      }).catch(error => {
        console.info(error)
      })
    },
    getQueryParams(extra) {
      const params = { ...extra }
      if (this.searchText) {
        params.key = this.searchText
      }
      if (this.searchTaskType) {
        params.taskType = this.searchTaskType
      }
      if (this.dateRange && this.dateRange.length === 2) {
        const start = Math.floor(this.dateRange[0].getTime() / 1000)
        const end = Math.floor(this.dateRange[1].getTime() / 1000)
        params.startTime = start
        params.endTime = end
      }
      return params
    },
    async handleSearch() {
      this.taskList = []
      this.page = 1
      await this.getTaskList(this.getQueryParams({ page: 1, limit: 10, status: this.showStatus }))
      //重置加载更多状态
      this.selectedTaskId = null
      if (this.taskList.length == 0) return
      this.selectedTask(this.taskList[0].id)
    },
    selectedTask(id) {
      this.loadingTaskDetail = true
      this.selectedTaskId = id

      getTaskInfo({ id }).then(res => {
        const data = res.data

        if (Array.isArray(data.itemToList)) {
          data.itemToList = data.itemToList.map(item => ({
            ...item,
            _popoverVisible: false
          }))
        }
        // 日志按时间倒序
        if (Array.isArray(data.taskLogListTo)) {
          data.taskLogListTo.sort((a, b) => b.createTime - a.createTime)
        }
        //this.taskLogList=data.taskLogListTo
        this.selectedTaskInfo = data
        this.loadingTaskDetail = false
      })
    },
    async selectAction(id, actionType) {
      const messages = {
        1: { tip: '是否确定完成该任务?', finish: '任务已完成.', api: completeTask },
        2: { tip: '是否确定取消该任务?', finish: '任务已取消.', api: cancelTask },
        3: { tip: '是否确定删除该任务?', finish: '任务已删除.', api: deleteTask }
      };

      const array = [id];
      const { tip, finish, api } = messages[actionType] || messages[3]; // 默认是删除

      try {
        await this.$confirm(tip, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });

        const response = await api(array); // 调用对应接口
        // 如果是删除接口需要额外获取 .data，也可以单独处理：
        // const result = actionType === 3 ? response.data : response;
        if (response.code == 200) {
          this.$message({
            type: 'success',
            message: finish
          });
          //修改切换任务,这里改为前端去除掉对应的任务
          const index = this.taskList.findIndex(item => item.id === id);
          if (index !== -1) {
            this.taskList.splice(index, 1);
          }
          this.selectedTaskId = null
          if (this.taskList.length == 0) return
          this.selectedTask(this.taskList[0].id)
        }
      } catch (err) {
        // 用户取消或请求失败都可以忽略或提示
        if (err !== 'cancel') {
          console.error('操作失败:', err);
        }
      }
    },
    async loadMove() {
      this.listLoadStatus = true
      if (this.page < this.pageCount) {
        //只有当前页数小于总页数才需要更新页
        await this.getTaskList({ page: this.page + 1, limit: this.limit, status: this.showStatus })
      }
      this.listLoadStatus = false
    },
    handleClose() {
      this.$confirm('确认关闭？')
        .then(() => {
          Object.assign(this.taskForm, {
            taskName: "",
            taskTime: null,
            itemToList: [],
            taskType: 1,
            annexFiles: []
          });
          this.drawer = false
          //清空一遍子组件的上传内容
          this.$refs.AnnexFileUpload.cleanFileList();
        })
        .catch(() => { return });
    },
    async editTaskOpen() {
      //获取到唯一码作为上传使用的
      await getUniqueCode().then(res => {
        this.uniqueCode = res.data
      })
      //将当前选择的任务样式给到选中任务表单
      this.taskForm.taskName = this.selectedTaskInfo.taskName
      this.taskForm.taskTime = new Date(this.selectedTaskInfo.taskTime * 1000)
      this.taskForm.itemToList = this.selectedTaskInfo.itemToList
      this.taskForm.taskType = this.selectedTaskInfo.taskType
      this.taskForm.annexFiles = this.selectedTaskInfo.annexFiles
      this.taskForm.description = this.selectedTaskInfo.description
      this.drawer = true
    },
    async shareTaskOpen() {
      if (!this.selectedTaskId) {
        this.$message.warning('请先选择任务')
        return
      }

      try {
        const res = await getShareCode({ id: this.selectedTaskId });

        if (res.code === 200 && res.data) {
          const shareCode = res.data;
          const mode = 'edit';
          // 构建完整分享链接
          this.shareUrl = `${window.location.origin}/#/shareTask?code=${shareCode}&mode=${mode}`;
          // 打开弹窗
          this.shareDialogVisible = true;
        } else {
          this.$message.error('获取分享码失败');
        }
      } catch (err) {
        console.error(err);
        this.$message.error('获取分享码异常');
      }
    },
    copyShareUrl() {
      const textarea = document.createElement('textarea')
      textarea.value = this.shareUrl
      document.body.appendChild(textarea)
      textarea.select()
      document.execCommand('copy')
      document.body.removeChild(textarea)
      this.$message.success('已复制到剪贴板')
    },

    goToShareUrl() {
      window.open(this.shareUrl, '_blank')
      this.shareDialogVisible = false
    },
    submitFormTask() {
      const payload = {
        ...this.taskForm,
        uniqueCode: this.uniqueCode,  // 这里加新属性
        id: this.selectedTaskId
      }
      payload.taskTime = Math.floor(payload.taskTime.getTime() / 1000);
      updateTask(payload).then(res => {
        if (res.code == 200) {
          this.$message.success('修改成功')
          Object.assign(this.taskForm, {
            taskName: "",
            taskTime: null,
            itemToList: [],
            taskType: 1,
            annexFiles: []
          });
          this.drawer = false
          //清空一遍子组件的上传内容
          this.$refs.AnnexFileUpload.cleanFileList();
          //重新刷新一下
          this.selectedTask(this.selectedTaskId)
        }
      })
    },
    addItem() {
      this.taskForm.itemToList.push({
        no: this.taskForm.itemToList.length + 1,
        itemContext: ''
      });
    },
    removeItem(index) {
      this.taskForm.itemToList.splice(index, 1);
      // 删除后重排序号
      this.taskForm.itemToList.forEach((item, i) => {
        item.no = i + 1;
      });
    },
    handleChangeItemLabel(item, dict) {
      // 直接修改当前 item，Vue 是响应式的
      item.label = dict.dictCode
      item.color = dict.color   // 如果 item 本身需要存颜色

      // 如果你后面要提交保存，这里不需要额外处理
      // selectedTaskInfo.itemToList 已经被同步修改
      item._popoverVisible = false
      console.info(this.selectedTaskInfo.itemToList)
      console.info(this.selectedTaskInfo.id)
      updateRemark({ "id": this.selectedTaskInfo.id, "itemToList": this.selectedTaskInfo.itemToList })
    },
    recordTaskLogOpen() {

      if (!this.selectedTaskId) {
        this.$message.warning("请先选择任务")
        return
      }

      this.taskLogForm = {
        logContent: '',
        annexFileList: []
      }

      this.logDialogVisible = true
    },
    saveTaskLogSubmit() {

      if (!this.taskLogForm.logContent) {
        this.$message.warning("请输入日志内容")
        return
      }

      const payload = {
        taskId: this.selectedTaskId,
        logContent: this.taskLogForm.logContent,
        annexFileList: this.taskLogForm.annexFileList
      }

      saveTaskLog(payload).then(res => {

        if (res.code == 200) {

          this.$message.success("日志保存成功")

          this.logDialogVisible = false

          // 刷新任务详情（重新加载日志）
          this.selectedTask(this.selectedTaskId)

        }

      })
    },
    editTaskLogOpen(log) {
      this.taskLogEditForm = {
        id: log.id,
        logContent: log.logContent,
        annexFileList: log.annexFileList ? JSON.parse(JSON.stringify(log.annexFileList)) : []
      }
      this.logEditDialogVisible = true
    },
    updateTaskLogSubmit() {
      if (!this.taskLogEditForm.logContent) {
        this.$message.warning("请输入日志内容")
        return
      }
      updateTaskLog(this.taskLogEditForm).then(res => {
        if (res.code == 200) {
          this.$message.success("日志更新成功")
          this.logEditDialogVisible = false
          this.selectedTask(this.selectedTaskId)
        }
      })
    },
    removeTaskLog(log) {
      this.$confirm('确定删除该日志吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteTaskLog([log.id]).then(res => {
          if (res.code == 200) {
            this.$message.success("日志已删除")
            this.selectedTask(this.selectedTaskId)
          }
        })
      }).catch(() => {})
    }
  },
  async created() {
    await this.getTaskList(this.getQueryParams({ page: 1, limit: 10, status: 1 }))
    //当加初次加载完成后，默认选中第一个任务
    if (this.taskList.length == 0) return
    this.selectedTask(this.taskList[0].id)
  },
  watch: {
    async showStatus(newValue) {
      this.taskList = []
      await this.getTaskList(this.getQueryParams({ page: 1, limit: 10, status: newValue }))
      this.selectedTaskId = null
      if (this.taskList.length == 0) return
      this.selectedTask(this.taskList[0].id)
    },
    searchText: {
      handler() {
        if (this._searchTimer) clearTimeout(this._searchTimer)
        this._searchTimer = setTimeout(() => {
          this.handleSearch()
        }, 300)
      },
      immediate: false
    },
    searchTaskType() {
      // 不自动搜索，通过弹窗中的搜索按钮触发
    },
    dateRange() {
      // 不自动搜索，通过弹窗中的搜索按钮触发
    }
  },
  computed: {
    loadLabelStatus() {
      return this.page < this.pageCount
    }
  }
};
</script>

<style scoped>
/* 顶部状态按钮优化 */
.status-button {
  padding: 8px 8px;
  background-color: #f5f5f5;
  text-align: center;
  border-radius: 7px;
  cursor: pointer;
  font-weight: 500;
  color: #666;
  transition: all 0.3s ease;
  margin: 0 10px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  border: 1px solid #ddd;
}

.status-button:hover {
  background-color: #e0e0e0;
}

.status-button.process {
  background-color: #409eff;
  color: white;
  border: none;
}

.status-button.finish {
  background-color: #67c23a;
  color: white;
  border: none;
}

.status-button.cancel {
  background-color: #f56c6c;
  color: white;
  border: none;
}

/* 设置 el-aside 外观 */
.aside-custom {
  background-color: #ffffff;
  border-radius: 10px;
  margin-right: 20px;
  padding-top: 30px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  display: flex;
  flex-direction: column;
  height: 100%;
  /* 填满容器高度 */
}

/* 输入+筛选图标整体布局优化 */
.popover-wrapper {
  display: flex;
  align-items: center;
  height: 40px;
  margin-bottom: 10px;
  padding: 0 5px;
}

/* 图标手型 + hover 提示 */
.icon {
  cursor: pointer;
  fill: #666;
  transition: all 0.2s;
}

.icon:hover {
  fill: #409eff;
  transform: scale(1.1);
}

/* 卡片样式优化 */
.task-card {
  width: 85%;
  height: 50px;
  margin: 10px 0;
  cursor: pointer;
  transition: all 0.3s ease;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  /* 内容靠左 */
  justify-content: center;
  font-weight: 500;
  padding: 16px;
  /* 加一点内边距 */
}

.task-card:hover {
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

/* 任务卡片主文字（任务名） */
.task-card > div:first-child {
  font-size: 14px;
  font-weight: 500;
  color: #333;
  font-family: "Microsoft YaHei", "PingFang SC", sans-serif;
}
/* 任务卡片时间文字 */
.task-card div:last-child {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
  font-family: "Microsoft YaHei", "PingFang SC", sans-serif;
  line-height: 1.4;
}
.load-label {
  width: 85%;
  font-size: 15px;
  color: #999;
  display: flex;
  justify-content: center;
  cursor: pointer;
}


/* 弹出表单优化（你可放在 style scoped 里） */
.el-popover .el-form {
  padding: 10px;
}

/* 主体与侧栏的布局间距 */
.el-aside {
  background-color: #ffffff;
  padding: 20px;
  border-radius: 10px;
  margin-right: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.el-main {
  background-color: #ffffff;
  padding: 20px;
  border-radius: 10px;
  min-height: 300px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.task-card.selected {
  background-color: rgb(234, 234, 234);
  /* 深色 */
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

ul {
  list-style-type: none;
}

li::before {
  color: #408af4;
}

.icon-wrapper {
  background-color: rgb(240, 240, 240);
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  transition: background-color 0.3s;
  cursor: pointer;
}

.icon-wrapper:hover {
  background-color: rgb(207, 207, 207);
  /* hover 时变灰一点 */
}

.icon-row {
  margin-top: 20px;
  display: flex;
}


.skeleton-container {
  padding: 20px;
  border-radius: 10px;
  background: #fff;
}

.skeleton-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.skeleton-avatar {
  width: 60px;
  height: 60px;
  border-radius: 8px;
  background: #eee;
  margin-right: 20px;
}

.skeleton-text-group {
  flex: 1;
}

.skeleton-title {
  height: 16px;
  width: 150px;
  background: #eee;
  margin-bottom: 10px;
  border-radius: 4px;
}

.skeleton-subtitle {
  height: 14px;
  width: 100px;
  background: #eee;
  border-radius: 4px;
}

.skeleton-line {
  height: 14px;
  background: #eee;
  border-radius: 4px;
  margin-bottom: 12px;
}

/* shimmer 动画 */
.shimmer {
  position: relative;
  overflow: hidden;
}

.shimmer::after {
  content: '';
  position: absolute;
  top: 0;
  left: -150px;
  height: 100%;
  width: 150px;
  background: linear-gradient(to right, transparent 0%, rgba(255, 255, 255, 0.5) 50%, transparent 100%);
  animation: shimmer 1.5s infinite;
}

.task-desc {
  padding-left: 24px; /* 减少缩进，更紧凑 */
  color: #555; /* 比主内容浅一点，做层次区分 */
  margin: 8px 0 16px 0;
  white-space: pre-wrap;
  word-wrap: break-word;
  font-size: 14px;
  font-family: "Microsoft YaHei", "PingFang SC", sans-serif;
  line-height: 1.7; /* 更大行高，适配长文本 */
  font-weight: 400;
}

@keyframes shimmer {
  100% {
    transform: translateX(300%);
  }
}

/* 滚动条整体 */
::-webkit-scrollbar {
  width: 6px;
  /* 垂直滚动条宽度 */
  height: 6px;
  /* 水平滚动条高度 */
}

/* 滚动条轨道（背景） */
::-webkit-scrollbar-track {
  background: transparent;
}

/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  background-color: rgba(144, 147, 153, 0.5);
  /* 滑块颜色 */
  border-radius: 3px;
  /* 圆角 */
}

/* 鼠标悬停时滑块颜色变化 */
::-webkit-scrollbar-thumb:hover {
  background-color: rgba(144, 147, 153, 0.7);
}

.card-scroll-area {
  overflow-y: auto;
  flex: 1;
  padding-right: 4px;
}

/* 标题样式 */
.remark-title {
  font-size: 15px;
  color: #333;
  font-weight: 600;
}

/* 列表样式 */
.remark-list {
  padding-left: 0px;
  margin-top: 0px;
  margin-bottom: 0;
  list-style: none;
}

/* 列表项样式 */
.remark-item {
  padding: 8px 10px;
  border-radius: 6px;
  transition: background-color 0.2s ease;
  display: flex;
  align-items: center;
}

.remark-item:hover {
  background-color: #fff;
}

/* 关键修改：标签徽章固定宽度容器 */
.tag-badge-container {
  display: inline-block;
  width: 80px;
  /* 固定宽度，可根据最长标签文字调整 */
  margin-right: 10px;
}

/* 标签徽章样式 */
.tag-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 3px 10px;
  width: 100%;
  /* 占满父容器宽度 */
  font-size: 12px;
  line-height: 18px;
  color: #fff;
  border-radius: 12px;
  /* 胶囊形状 */
  cursor: pointer;
  box-sizing: border-box;
  /* 确保padding不影响宽度 */
}

/* 编号样式 */
.item-number {
  font-weight: 600;
  color: #408af4;
  display: inline-block;
}

/* 内容样式 */
.item-content {
  margin-left: 6px;
  color: #444; /* 介于主内容和描述之间 */
  font-size: 14px;
  line-height: 1.6;
  font-family: "Microsoft YaHei", "PingFang SC", sans-serif;
  font-weight: 400;
}

/* 弹出层选项容器 */
.tag-options {
  padding: 8px 0;
}

/* 弹出层选项项 */
.tag-option-item {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  font-size: 13px;
}

.tag-option-item:hover {
  background-color: #f5f7fa;
}

/* 颜色圆点 */
.tag-color-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 8px;
}

/* 标签名称 */
/* 标签名称（未分类/各类标签） */
.tag-name {
  color: #333;
  font-size: 13px;
  font-family: "Microsoft YaHei", "PingFang SC", sans-serif;
  font-weight: 500; /* 轻微加粗，小字体更清晰 */
}
/* 弹出层选项文字（标签选择器） */
.tag-option-item {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  font-size: 13px;
  font-family: "Microsoft YaHei", "PingFang SC", sans-serif;
  line-height: 1.5;
}

/* 最后一个列表项取消下边距 */
.remark-list .remark-item:last-child {
  margin-bottom: 0;
}
</style>

<!-- 非scoped样式，用于修改Element UI弹出层样式 -->
<style>
/* 关键修改：仅保留hover阴影效果 */
.remark-tag-popover {
  border-radius: 8px !important;
  border: 1px solid #e9ecef !important;
  transition: box-shadow 0.2s ease !important;
}

/* 冒泡框hover阴影 */
.remark-tag-popover:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
}

/* 重置Element UI默认阴影，仅保留hover时显示 */
.remark-tag-popover.el-popper[x-placement^=right] {
  box-shadow: none !important;
}
/* 任务信息内容（名称/时间/类型/计划说明/附件）- 主内容样式 */
.task-info-content {
  margin-bottom: 12px;
  font-size: 14px;
  color: #333; /* 加深主文本色，提升对比度 */
  font-family: "Microsoft YaHei", "PingFang SC", sans-serif; /* 增加苹方，适配Mac */
  line-height: 1.6; /* 增大行高，提升可读性 */
  font-weight: 400;
}
/* 任务日志内容 - 与任务描述样式统一 */
.task-log-content {
  padding-left: 8px;
  color: #555;
  margin: 8px 0 16px 0;
  white-space: pre-wrap;
  word-wrap: break-word;
  font-size: 14px;
  font-family: "Microsoft YaHei", "PingFang SC", sans-serif;
  line-height: 1.7;
  font-weight: 400;
}

</style>
